import ConstructorIOClient from '@constructor-io/constructorio-node';
import getConfig from 'next/config';

import { CONSTRUCTOR_SERVICE_URL } from 'search/enums/constants';

// TODO: Instantiate this client once throughout the entire session
const { publicRuntimeConfig } = getConfig();
// Node Client to be used on server-side. Use useConstructorClient on client-side
// Docs: https://constructor-io.github.io/constructorio-node/index.html
// we need to send userParameters as the final param (getConstructorNodeClientUserParams)
export const ConstructorNodeClient = new ConstructorIOClient({
  apiKey: publicRuntimeConfig.CONSTRUCTOR_API_KEY,
  securityToken: publicRuntimeConfig.CONSTRUCTOR_SECURITY_TOKEN,
  serviceUrl: CONSTRUCTOR_SERVICE_URL,
});
